 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		68: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"3":"component---src-pages-action-potential-index-jsx","4":"component---src-pages-adhd-states-index-jsx","5":"component---src-pages-antipsychotic-medications-index-jsx","6":"component---src-pages-anxiety-causes-index-jsx","7":"component---src-pages-anxiety-countries-index-jsx","8":"component---src-pages-apple-eye-index-jsx","9":"component---src-pages-autism-spectrum-index-jsx","10":"component---src-pages-brain-electricity-index-jsx","11":"component---src-pages-brainstem-cerebellum-index-jsx","12":"component---src-pages-brief-presentation-index-jsx","13":"component---src-pages-celebrities-disorders-index-jsx","14":"component---src-pages-client-therapy-index-jsx","15":"component---src-pages-cognitive-therapy-index-jsx","16":"component---src-pages-college-student-index-jsx","17":"component---src-pages-deep-thinking-index-jsx","18":"component---src-pages-depression-index-jsx","19":"component---src-pages-disconnected-hemispheres-index-jsx","20":"component---src-pages-dopamine-hypothesis-index-jsx","21":"component---src-pages-dsm-5-index-jsx","22":"component---src-pages-emotive-therapy-index-jsx","23":"component---src-pages-exposure-therapy-index-jsx","24":"component---src-pages-factor-analyze-index-jsx","25":"component---src-pages-false-information-index-jsx","26":"component---src-pages-fear-response-index-jsx","27":"component---src-pages-fight-flight-index-jsx","28":"component---src-pages-gender-personality-index-jsx","29":"component---src-pages-gestalt-therapy-index-jsx","30":"component---src-pages-glove-anesthesia-index-jsx","31":"component---src-pages-green-space-index-jsx","32":"component---src-pages-hebbian-learning-index-jsx","33":"component---src-pages-index-jsx","34":"component---src-pages-irrational-beliefs-index-jsx","35":"component---src-pages-learning-draw-index-jsx","36":"component---src-pages-learning-everywhere-index-jsx","37":"component---src-pages-means-variability-index-jsx","38":"component---src-pages-memory-chunking-index-jsx","39":"component---src-pages-memory-interference-index-jsx","40":"component---src-pages-memory-reconsolidation-index-jsx","41":"component---src-pages-mood-disorders-index-jsx","42":"component---src-pages-neuron-structure-2-index-jsx","43":"component---src-pages-neuron-structure-index-jsx","44":"component---src-pages-ocd-index-jsx","45":"component---src-pages-perception-schizophrenia-index-jsx","46":"component---src-pages-pick-research-method-index-jsx","47":"component---src-pages-play-fire-index-jsx","48":"component---src-pages-popular-anxiolytics-index-jsx","49":"component---src-pages-psychodynamic-therapy-index-jsx","50":"component---src-pages-psychology-timeline-index-jsx","51":"component---src-pages-remembering-knowing-index-jsx","52":"component---src-pages-resmeth-data-cycle-index-jsx","53":"component---src-pages-schizophrenia-index-jsx","54":"component---src-pages-secondary-reinforcers-index-jsx","55":"component---src-pages-sensory-motor-index-jsx","56":"component---src-pages-sensory-motor-old-index-jsx","57":"component---src-pages-significant-features-index-jsx","58":"component---src-pages-social-anxiety-index-jsx","59":"component---src-pages-stress-response-index-jsx","60":"component---src-pages-study-habits-index-jsx","61":"component---src-pages-studying-development-index-jsx","62":"component---src-pages-subcortical-brain-index-jsx","63":"component---src-pages-subcortical-brain-old-index-jsx","64":"component---src-pages-susceptible-memories-index-jsx","65":"component---src-pages-tardive-dyskinesia-index-jsx","66":"component---src-pages-top-down-index-jsx","67":"component---src-pages-working-memory-index-jsx"}[chunkId]||chunkId) + "-" + {"3":"25a12fe8bf550bc12aaf","4":"46836c8d91aac90b699d","5":"80601fadfbad3c3b5f1f","6":"cf011e5c985401ebcbf2","7":"a0676dc359a09842e977","8":"eb840353f6ab264d1c53","9":"802badc9458297d215d6","10":"38e100f6f9646a5d89cc","11":"26df6a570b7860396bd7","12":"8cd305cbd17ba4b41c8b","13":"8a0faec20c2080e077cc","14":"511f15c96c657393fe03","15":"2407a084493766915eed","16":"fc1f4680d5d697521379","17":"dfe0cb8f70be3ded76de","18":"2b36078fa5329f938520","19":"82ed382ad4a185f9b194","20":"bb063c493c4ba55b21d1","21":"39500efa24927e5e47d8","22":"059a8fc975fcb9a8deb6","23":"fcdd514a6c545fdc3366","24":"e975669c471f32347b15","25":"5e229b18672109be66eb","26":"00e132c8c379e83bff8e","27":"92c81cdb6b2b8b7682d6","28":"f7070502ffe7ce93374d","29":"ed5feab5fd53e09d1349","30":"f44400b4086047de7d1b","31":"61e97aa2b4ccfa9b4a38","32":"e539fb48c5283619b9ff","33":"24fdf0c50afa4fc5819f","34":"f8b404016500528fe283","35":"0cf79ede576c15b690e7","36":"321a143dff0da5ed9cad","37":"c3f5ce5ef3afc7ebc842","38":"f72683477a64dd4b22f2","39":"d94f27b760c40fca2f2f","40":"22871ac5c648cb106d8c","41":"9185486aa817ad441e83","42":"0d5054a4097777ca9157","43":"9e886814d3c440550454","44":"3237b6dd74473a7a3fcb","45":"2faf5aaac19b92771a7e","46":"44bd9cb18b7158961367","47":"0822fd14ec59280acaa9","48":"92a69b8dc52638e3491d","49":"53d9bde02deee527399b","50":"1375bb701ea581a12a35","51":"989bf01bb2683c987beb","52":"6313ca4ad70e58ee7d9a","53":"d93cd19659f58c6a1262","54":"c8adf6656c1f24516bf1","55":"f47d70d45fcdcb40f85f","56":"8f6883275424172b003c","57":"6201fbb7139e1dd3783a","58":"4b3eadee48395a83b0f6","59":"05455c0e61ff37d4d8cd","60":"93d67d2e0be4c0f72d48","61":"f4f50216e85ab3fe5d45","62":"507d1306a0a1463f3525","63":"b6413f89e2c42ce8ab1e","64":"fd83aff4917d94fd4f6c","65":"8a73d28143b45d07bfc4","66":"cee01578c5f2835f2b53","67":"286124d30f2047cc6653"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
